import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Drawer, Select, Alert } from "antd";

import { create as CreateSurgicalProcedure } from "../../api/SurgicalProcedure";
import { update as UpdateSurgicalProcedure } from "../../api/SurgicalProcedure";

import Text from "antd/lib/typography/Text";

import { siips_values, types } from '../../constants';

const { Option } = Select;

const layoutForm = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3"
  },
};

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
  style: { width: 250 },
};

const SurgicalProcedureForm = (props) => {
  const { surgicalProcedure } = props;
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async () => {
    let values = getValues();

    if (surgicalProcedure) {
      await UpdateSurgicalProcedure(surgicalProcedure.id, values);
    } else {
      await CreateSurgicalProcedure(values);
    }

    props.onCreated();
    form.resetFields();
  };

  const getValues = () => {
    let fiedlsValues = form.getFieldsValue();

    let values = {};
    let interfaceFields = ["siips_base", "siips_technical", "siips_relational"];
    Object.keys(fiedlsValues).filter((item) => !interfaceFields.includes(item))
      .forEach((item) => {
        values[item] = fiedlsValues[item];
      });

    values["siips"] = {
      "base": fiedlsValues["siips_base"],
      "technical": fiedlsValues["siips_technical"],
      "relational": fiedlsValues["siips_relational"],
    };

    return values
  }

  const onFinishFailed = (errorInfo) => {
    form.resetFields();
    // @todo a implementé
    console.log("Failed:", errorInfo);
  };

  const onClose = () => {
    props.onClose();
    form.resetFields();
  };

  const onClickSuggestedDurationHandler = function() {
    form.setFieldsValue({
      duration_of_stay: surgicalProcedure.suggested_duration_of_stay
    });
  }

  useEffect(() => {
    setVisible(props.visible);
  });

  let initialValues = {
    name: null,
    type: null,
    duration_of_stay: null,
    siips_base: null,
    siips_technical: null,
    siips_relational: null
  };

  useEffect(() => {

    if (surgicalProcedure) {
      initialValues = {
        name: surgicalProcedure.name,
        type: surgicalProcedure.type,
        duration_of_stay: surgicalProcedure.duration_of_stay,
        siips_base: surgicalProcedure.siips.base,
        siips_technical: surgicalProcedure.siips.technical,
        siips_relational: surgicalProcedure.siips.relational
      };
    }

    form.setFieldsValue(initialValues);
  }, [surgicalProcedure]);

  let typeOptions = types.map((option, index) => (
    <Option key={index} value={option.id}>{option.label}</Option>
  ));

  let chargeOptions = siips_values.map((option, index) => (
    <Option key={index} value={option}>{option}</Option>
  ));

  let suggested = '';
  if (surgicalProcedure
      && surgicalProcedure.suggested_duration_of_stay !== null
      && surgicalProcedure.suggested_duration_of_stay !== surgicalProcedure.duration_of_stay) {

    let suggestedMessage = (
      <span>
        L'analyse des dernières interventions suggère une durée de&nbsp;
        <Text strong underline>{surgicalProcedure.suggested_duration_of_stay} nuits</Text>
      </span>
    )
    suggested = (
      <Form.Item label="-">
        <Alert
          type="info"
          showIcon
          message={suggestedMessage}
          action={
            <Button onClick={onClickSuggestedDurationHandler}>
              Appliquer cette nouvelle valeur
            </Button>
          }
        />
      </Form.Item>
    );
  }

  let drawerTitle = "Ajout d'une nouvelle procédure";
  if (surgicalProcedure) {
    drawerTitle = "Modification d'une procédure";
  }

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width="800px"
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button onClick={onFinish} type="primary">
            Enregistrer
          </Button>
        </div>
      }
    >
      <Form
        {...layoutForm}
        form={form}
        name="surgical_procedure"
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item label="Nom" name="name">
          <Input className="ant-input-text" placeholder="Procedure n°XX" />
        </Form.Item>
        <Form.Item label="Type de chirurgie" name="type">
          <Select {...layoutSelect} placeholder="Sélectionnez un type">
            {typeOptions}
          </Select>
        </Form.Item>
        <Form.Item label="Nombre de nuits" name="duration_of_stay">
          <InputNumber style={{ width: 80 }} placeholder="4" min={0} />
        </Form.Item>
        {suggested}
        <Form.Item label="Soin de Base" name="siips_base">
          <Select {...layoutSelect} style={{ width: 80 }} placeholder="1">
            {chargeOptions}
          </Select>
        </Form.Item>
        <Form.Item label="Soin Technique" name="siips_technical">
          <Select {...layoutSelect} style={{ width: 80 }} placeholder="1">
            {chargeOptions}
          </Select>
        </Form.Item>
        <Form.Item label="Soin Relationnel" name="siips_relational">
          <Select {...layoutSelect} style={{ width: 80 }} placeholder="1">
            {chargeOptions}
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SurgicalProcedureForm;